import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback as l, useMemo as x, useState as T, createRef as V } from "react";
var G = function G(a) {
    return a.reduce(function (o, u) {
      return o + u.value;
    }, 0);
  },
  C = function C(a) {
    var o = Object.keys(a).find(function (i) {
        return a[i].type === "location";
      }),
      u = Object.keys(a).find(function (i) {
        return i !== o && a[i].type === "location";
      });
    return !o || !u ? null : [o, u];
  },
  w = function w(_ref) {
    var a = _ref.formSchema;
    var _T = T(function () {
        var t = {};
        return Object.keys(a).forEach(function (e) {
          var n = a[e];
          t[e] = {
            type: n.type,
            value: n.defaultValue,
            totalCount: n.type === "peopleCount" ? G(n.defaultValue) : void 0
          };
        }), t;
      }),
      _T2 = _slicedToArray(_T, 2),
      o = _T2[0],
      u = _T2[1],
      i = x(function () {
        return Object.keys(a).reduce(function (t, e) {
          return t[e] = V(), t;
        }, {});
      }, []),
      f = l(function (t) {
        var n, s, r, c, y, p;
        if (!t) return;
        var e = o[t].type;
        if (e === "date") {
          var d = (n = i[t].current) == null ? void 0 : n.querySelector("[data-input]");
          (d == null ? void 0 : d.getAttribute("type")) === "hidden" && (d = (s = i[t].current) == null ? void 0 : s.querySelector(".form-control.input")), d == null || d.focus();
          return;
        }
        if (e === "location") return (c = (r = i[t].current) == null ? void 0 : r.focus) == null ? void 0 : c.call(r);
        (p = (y = i[t].current) == null ? void 0 : y.click) == null || p.call(y);
      }, [i]),
      v = l(function (t, e) {
        u(function (n) {
          return _objectSpread(_objectSpread({}, n), {}, _defineProperty({}, t, _objectSpread(_objectSpread({}, n[t]), {}, {
            value: e
          })));
        });
      }, []),
      g = l(function (t, e) {
        u(function (n) {
          return _objectSpread(_objectSpread({}, n), {}, _defineProperty({}, t, _objectSpread(_objectSpread({}, n[t]), e)));
        });
      }, []),
      m = l(function (t, e, n) {
        var s = _toConsumableArray(o[t].value),
          r = s.findIndex(function (c) {
            return e.name === c.name;
          });
        s[r].value = n, g(t, {
          value: s,
          totalCount: G(s)
        });
      }, [o]),
      O = l(function (t, e) {
        return function () {
          m(e, t, t.value - 1);
        };
      }, [m]),
      F = l(function (t, e) {
        return function () {
          m(e, t, t.value + 1);
        };
      }, [m]),
      b = l(function (t, e) {
        return e === "plus" ? t.value >= (t.max || 100) : t.value === 0;
      }, []),
      S = l(function (t) {
        var e = (t == null ? void 0 : t.length) === 2 ? t : C(o);
        !e || (g(e[0], o[e[1]]), g(e[1], o[e[0]]));
      }, [o]),
      k = l(function (_ref2) {
        var t = _ref2.convertDate;
        var e = {};
        return Object.keys(o).forEach(function (n) {
          var c, y;
          var s = o[n];
          var r = "";
          if (s.type === "date") {
            var p = (c = s.value) == null ? void 0 : c[0];
            r = t ? t(p) : p;
          }
          if (s.type === "peopleCount") {
            s.value.forEach(function (p) {
              e["".concat(n, "-").concat(p.name)] = p.value;
            });
            return;
          }
          s.type === "location" && (r = (y = s.value) == null ? void 0 : y.value), e[n] = r;
        }), new URLSearchParams(e).toString();
      }, [o]);
    return x(function () {
      return {
        formSchema: a,
        state: o,
        setState: u,
        setFieldValue: v,
        setFieldState: g,
        refs: i,
        focusOn: f,
        setGuestOptionValue: m,
        onMinusClick: O,
        onPlusClick: F,
        getIsOptionDisabled: b,
        swapLocations: S,
        serializeToURLParams: k
      };
    }, [a, o, u, i, v, f, g, O, F, b, S, k]);
  };
export { w as useReactBookingForm };